import React, { useEffect, useState } from 'react';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Upload, message } from 'antd';
import type { RcFile } from 'antd/es/upload/interface';
import axios from 'axios';
import { guidGenerator } from 'mixins/helpers';
import {
    HOME_BANNER_IMAGE_ACCEPT,
    HOME_BANNER_IMAGE_ACCEPTED_TYPES,
    HOME_BANNER_IMAGE_PARENT,
    HOME_BANNER_IMAGE_UPLOAD_URL,
    getHomeBannerIconUrl,
} from '../home-banners/constants';

type Props = {
    value?: string;
    onChange?: (imageId: string) => void;
};

type CreateMediaResponse = {
    id?: string;
    _id?: string;
};

const getExtension = (file: RcFile): string => {
    const nameParts = file.name.split('.');
    const fallback = file.type.split('/')[1] || 'png';

    return nameParts.length > 1 ? nameParts.pop() || fallback : fallback;
};

const HomeBannerImageUpload = ({ value, onChange }: Props) => {
    const [loading, setLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState<string>();

    useEffect(() => {
        setImageUrl(value ? getHomeBannerIconUrl(value) : undefined);
    }, [value]);

    const uploadImage = async (file: RcFile): Promise<void> => {
        const formData = new FormData();
        const extension = getExtension(file);

        formData.append('file', file);
        formData.append('parent', HOME_BANNER_IMAGE_PARENT);
        formData.append('name', `${guidGenerator()}.${extension}`);

        const response = await axios.post<CreateMediaResponse>(HOME_BANNER_IMAGE_UPLOAD_URL, formData);
        const imageId = response.data.id || response.data._id;

        if (!imageId) {
            throw new Error('Image upload response does not contain id');
        }

        onChange?.(imageId);
        setImageUrl(getHomeBannerIconUrl(imageId));
    };

    const beforeUpload = (file: RcFile): boolean => {
        if (!HOME_BANNER_IMAGE_ACCEPTED_TYPES.includes(file.type)) {
            message.error('Поддерживаются только JPG, JPEG, PNG и WEBP');
            return false;
        }

        setLoading(true);
        uploadImage(file)
            .catch((error) => {
                console.error(error);
                message.error('Не удалось загрузить изображение');
            })
            .finally(() => setLoading(false));

        return false;
    };

    return (
        <Upload
            name="image"
            listType="picture-card"
            showUploadList={false}
            beforeUpload={beforeUpload}
            accept={HOME_BANNER_IMAGE_ACCEPT}
        >
            {imageUrl ? (
                <img
                    src={imageUrl}
                    alt="banner"
                    className="home-banners-admin__upload-preview"
                />
            ) : (
                <div>
                    {loading ? <LoadingOutlined /> : <PlusOutlined />}
                    <div className="home-banners-admin__upload-text">Загрузить</div>
                </div>
            )}
        </Upload>
    );
};

export default HomeBannerImageUpload;
